if (!customElements.get('klaviyo-bis-trigger')) {
  customElements.define(
    'klaviyo-bis-trigger',
    class KlaviyoBisTrigger extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.publicKey = this.dataset.publicKey;
        this.productId = this.dataset.productId;
        this.productFormId = this.dataset.productFormId;
        this.useCustom = this.dataset.useCustom === 'true';

        this.button.addEventListener('click', this.onClickHandler.bind(this));
      }

      onClickHandler(e) {
        if (e) e.preventDefault();

        if (!this.publicKey || this.publicKey === 'PLACEHOLDER') {
          alert('Please configure the Klaviyo Public API Key in Theme Settings > Klaviyo.');
          return;
        }

        const form = document.getElementById(this.productFormId);
        if (!form) {
          console.error('Klaviyo BIS: Product form not found:', this.productFormId);
          return;
        }

        const variantIdInput = form.querySelector('[name="id"]');
        if (!variantIdInput) {
          console.error('Klaviyo BIS: Variant ID input not found in form:', this.productFormId);
          return;
        }

        this.variantId = variantIdInput.value;

        if (this.useCustom) {
          this.showCustomModal();
        } else {
          this.triggerDefaultKlaviyoModal();
        }
      }

      triggerDefaultKlaviyoModal() {
        const klaviyo = window.klaviyo || [];
        const variantId = parseInt(this.variantId);
        const productId = this.productId;

        console.log('Klaviyo BIS: Triggering official modal', { variantId, productId });

        // Standard approach: push to _learnq
        var _learnq = window._learnq || [];
        _learnq.push([
          'openBackInStockModal',
          {
            variantId: variantId,
            productId: productId,
          },
        ]);

        // Modern approach: call directly if available
        if (klaviyo.openBackInStockModal) {
          try {
            klaviyo.openBackInStockModal({
              variantId: variantId,
              productId: productId,
            });
          } catch (e) {
            console.warn('Klaviyo BIS: modern call failed, relying on queue:', e);
          }
        }
      }

      showCustomModal() {
        // Create Overlay
        const overlay = document.createElement('div');
        overlay.id = 'klaviyo-bis-overlay';
        overlay.style.cssText = `
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 100% !important;
          background: rgba(62, 32, 21, 0.4) !important;
          z-index: 2147483646 !important;
          -webkit-backdrop-filter: blur(4px) !important;
          display: block !important;
        `;
        document.body.appendChild(overlay);

        // Create Modal
        const modal = document.createElement('div');
        modal.id = 'klaviyo-bis-modal';
        modal.style.cssText = `
          position: fixed !important;
          top: 50% !important;
          left: 50% !important;
          transform: translate(-50%, -50%) !important;
          background: #f3f2ee !important;
          border-radius: 28px !important;
          box-shadow: 0 30px 70px rgba(62, 32, 21, 0.1) !important;
          z-index: 2147483647 !important;
          max-width: 560px !important;
          width: 90% !important;
          text-align: center !important;
          font-family: inherit !important;
          display: block !important;
        `;
        modal.innerHTML = `
          <style>
            #klaviyo-bis-modal {
              width: min(92vw, 540px); /* Compact and elegant */
              padding: 52px 32px 44px;
              background: #f3f2ee !important;
              border: 1px solid rgba(62, 32, 21, 0.05) !important;
            }
            #klaviyo-bis-modal .bis-copy {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 28px;
              text-align: center;
            }
            #klaviyo-bis-modal #bis-modal-title {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 0 16px 0 !important;
              color: #3E2015 !important;
              font-size: 18px !important;
              font-weight: 600 !important;
              line-height: 1.3 !important;
              letter-spacing: -0.01em !important;
            }
            #klaviyo-bis-modal #bis-modal-desc {
              width: 100% !important;
              max-width: 300px !important;
              color: #3E2015 !important;
              font-size: 12px !important;
              line-height: 1.6 !important;
              margin: 0 !important;
              opacity: 0.7 !important;
              letter-spacing: 0.01em !important;
            }
            #klaviyo-bis-modal #bis-form-content {
              width: 100%;
              max-width: 360px;
              margin: 0 auto;
            }
            #bis-email {
              width: 100% !important;
              height: 52px !important;
              padding: 0 18px !important;
              margin: 0 !important;
              border: 1px solid #3E2015 !important;
              border-radius: 10px !important;
              background: #f3f2ee !important;
              font-size: 14px !important;
              box-sizing: border-box !important;
              color: #3E2015 !important;
              outline: none !important;
              text-align: left !important;
              -webkit-appearance: none !important;
              display: block !important;
              transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            }
            #bis-email:focus {
              border-color: #3E2015 !important;
              box-shadow: 0 0 0 4px rgba(62, 32, 21, 0.05) !important;
            }
            #bis-submit {
              width: 100%;
              min-height: 52px;
              padding: 12px 20px;
              background: #3E2015;
              color: #FFFFFF;
              border: none;
              border-radius: 10px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 600;
              text-transform: none;
              letter-spacing: 0.04rem;
              transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
              margin-top: 10px;
              box-shadow: 0 4px 12px rgba(62, 32, 21, 0.1);
            }
            #bis-submit:hover {
              background: #2D170F;
              transform: translateY(-2px);
              box-shadow: 0 8px 24px rgba(62, 32, 21, 0.2);
            }
            #close-mock-modal-icon {
              position: absolute;
              top: 16px;
              right: 20px;
              background: none;
              border: none;
              cursor: pointer;
              width: 36px;
              height: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #3E2015;
              border-radius: 50%;
              transition: all 0.3s ease;
              opacity: 1;
              padding: 0;
            }
            #close-mock-modal-icon:hover {
              opacity: 1;
              background: rgba(62, 32, 21, 0.05);
              transform: rotate(90deg);
            }
            #close-mock-modal-icon svg {
              width: 12px;
              height: 12px;
            }
            @media screen and (min-width: 990px) {
              #klaviyo-bis-modal {
                width: min(92vw, 560px) !important;
                max-width: 560px !important;
                padding: 72px 64px 64px !important;
                border-radius: 28px !important;
                box-shadow:
                  0 0 0 1px rgba(62, 32, 21, 0.02),
                  0 10px 20px rgba(62, 32, 21, 0.04),
                  0 30px 70px rgba(62, 32, 21, 0.1) !important;
              }
              #klaviyo-bis-modal #bis-modal-title {
                max-width: 100% !important;
                margin-bottom: 20px !important;
                font-size: 28px !important;
                font-weight: 600 !important;
              }
              #klaviyo-bis-modal #bis-modal-desc {
                max-width: 400px !important;
                font-size: 16px !important;
              }
              #klaviyo-bis-modal #bis-form-content {
                max-width: 400px !important;
              }
              #bis-email {
                height: 58px !important;
                font-size: 15px !important;
              }
              #bis-submit {
                min-height: 58px !important;
                font-size: 14px !important;
                letter-spacing: 0.1em !important;
              }
              #close-mock-modal-icon {
                top: 20px !important;
                right: 24px !important;
              }
              #close-mock-modal-icon svg {
                width: 14px;
                height: 14px;
              }
            }
          </style>
          <button id="close-mock-modal-icon">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="3.0" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="bis-copy">
            <h2 id="bis-modal-title">Be the first to know when it’s back</h2>
            <p id="bis-modal-desc">
              This piece is temporarily sold out. We’re working on bringing it back. Enter your email address below and we’ll reach out as soon as it’s available.
            </p>
          </div>
          <div id="bis-form-content">
            <input type="email" id="bis-email" placeholder="Enter Your Email Address">
            <button id="bis-submit">Notify Me</button>
          </div>
          <p id="bis-error" style="color: #900; font-size: 12px; margin-top: 10px; display: none;"></p>
        `;
        document.body.appendChild(modal);

        const close = () => {
          document.body.removeChild(modal);
          document.body.removeChild(overlay);
        };
        modal.querySelector('#close-mock-modal-icon').addEventListener('click', close);
        overlay.addEventListener('click', close);

        // Submit Logic
        const submitBtn = modal.querySelector('#bis-submit');
        submitBtn.addEventListener('click', () => this.handleFormSubmit(modal));
      }

      async handleFormSubmit(modal) {
        const emailInput = modal.querySelector('#bis-email');
        const errorMsg = modal.querySelector('#bis-error');
        const submitBtn = modal.querySelector('#bis-submit');
        const email = emailInput.value.trim();

        if (!email || !email.includes('@')) {
          errorMsg.textContent = 'Please enter a valid email address.';
          errorMsg.style.display = 'block';
          return;
        }

        errorMsg.style.display = 'none';
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
        submitBtn.textContent = 'Submitting...';

        if (this.publicKey === 'MOCK_KEY') {
          // Local testing simulation
          setTimeout(() => {
            this.showSuccessState(modal);
          }, 1000);
          return;
        }

        // Modern Klaviyo Client API (v3)
        // Endpoint: https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PUBLIC_KEY
        const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.publicKey}`;

        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.variantId}`,
                },
              },
            },
          },
        };

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              Revision: '2024-10-15', // Use a stable recent revision
            },
            body: JSON.stringify(payload),
          });

          if (response.ok || response.status === 202) {
            this.showSuccessState(modal);
          } else {
            const result = await response.json();
            console.error('Klaviyo BIS Error Detail:', result);
            errorMsg.textContent = result.errors?.[0]?.detail || 'Something went wrong. Please try again.';
            errorMsg.style.display = 'block';
            submitBtn.disabled = false;
            submitBtn.style.opacity = '1';
            submitBtn.textContent = 'Notify Me';
          }
        } catch (error) {
          console.error('Klaviyo BIS Network Error:', error);
          errorMsg.textContent = 'Network error. Please try again later.';
          errorMsg.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
          submitBtn.textContent = 'Notify Me';
        }
      }

      showSuccessState(modal) {
        const formContent = modal.querySelector('#bis-form-content');
        const title = modal.querySelector('#bis-modal-title');
        const desc = modal.querySelector('#bis-modal-desc');

        formContent.style.display = 'none';
        title.textContent = `You're on the list!`;
        desc.textContent = 'We’ll reach out as soon as this item is available again. Thank you!';

        // Auto-close after 3 seconds
        setTimeout(() => {
          const m = document.getElementById('klaviyo-bis-modal');
          const o = document.getElementById('klaviyo-bis-overlay');
          if (m) document.body.removeChild(m);
          if (o) document.body.removeChild(o);
        }, 3000);
      }
    },
  );
}
